/**
 * DevExtreme (ui/data_grid/ui.data_grid.master_detail.js)
 * Version: 18.2.4
 * Build date: Mon Dec 17 2018
 *
 * Copyright (c) 2012 - 2018 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
"use strict";
var gridCore = require("./ui.data_grid.core"),
    masterDetailModule = require("../grid_core/ui.grid_core.master_detail");
gridCore.registerModule("masterDetail", masterDetailModule);



//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/node_modules/devextreme/ui/data_grid/ui.data_grid.master_detail.js
// module id = ../../../../devextreme/ui/data_grid/ui.data_grid.master_detail.js
// module chunks = common